/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AffectedGoals = "AttendMeeting" | "ConvenientMeetingTime" | "EmailTriage" | "FocusTask" | "FocusTime" | "Lunch" | "MeetingRelief" | "NoMeetingDay" | "PersonalObligation" | "PreferredWork" | "PrepTime" | "Task" | "TravelTime" | "WithinMeetingHours" | "WithinWorkingHours" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob = {
    readonly knobUrn: {
        readonly id: string;
        readonly type: UrnType | null;
        readonly value: string | null;
    };
    readonly externalEventId: string;
    readonly affectedGoals: ReadonlyArray<AffectedGoals | null>;
    readonly knobScore: number;
    readonly __typename: "LessenAutopilotConstraintKnob";
    readonly " $refType": "AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob";
};
export type AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob$data = AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob;
export type AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob$key = {
    readonly " $data"?: AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutopilotSuggestionLessenConstraint_lessenAutopilotConstraintKnob",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Urn",
            "kind": "LinkedField",
            "name": "knobUrn",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalEventId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "affectedGoals",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "knobScore",
            "storageKey": null
        }
    ],
    "type": "LessenAutopilotConstraintKnob",
    "abstractKey": null
} as any;
(node as any).hash = '2ccbe47cfcce75726c183bd18066686e';
export default node;
